import { render, staticRenderFns } from "./popular-searches.vue?vue&type=template&id=3695776f&"
import script from "./popular-searches.vue?vue&type=script&lang=ts&"
export * from "./popular-searches.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports